import clsx from 'clsx'
import { useState } from 'react'

import styles from './PlayIcon.module.scss'

interface PlayIconProps {
  className?: string
  hoverActive?: boolean
  onClick?: () => void
}

const PlayIcon = ({ className, hoverActive, onClick }: PlayIconProps) => {
  const [hover, setHover] = useState(false)

  const handleHover = () => {
    if (hoverActive) setHover(!hover)
  }

  return (
    <div className={className} onMouseEnter={handleHover} onMouseLeave={handleHover} onClick={onClick}>
      <svg
        className={clsx(hover && styles.showCursor)}
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1638_2723)">
          <circle cx="36" cy="36" r="36" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M52.2002 35.8707C52.2002 36.5138 51.8571 37.108 51.3002 37.4296L29.7002 49.9004C29.1433 50.2219 28.4571 50.2219 27.9002 49.9004C27.3433 49.5788 27.0002 48.9846 27.0002 48.3415L27.0002 23.4C27.0002 22.7569 27.3433 22.1627 27.9002 21.8411C28.4571 21.5196 29.1433 21.5196 29.7002 21.8411L51.3002 34.3119C51.8571 34.6334 52.2002 35.2277 52.2002 35.8707ZM30.6002 26.5177L30.6002 45.2238L46.8002 35.8707L30.6002 26.5177Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1638_2723">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default PlayIcon
